import React, { useState, useEffect } from 'react';
import moment from 'moment';

// mui material
import {
    Box,
    Grid,
    IconButton,
    Tooltip,
    Typography
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterListTwoTone';

// project import
import MainCard from 'ui-component/cards/MainCard';
import PaginationRows from 'ui-component/extended/PaginationRows';
import List from './List';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import Filter from './Filter';

const BoardLog = ({ boardUuid }) => {

    const [total, setTotal] = useState(1);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [limit, setLimit] = useState(10);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState(false);
    const [filterObj, setFilterObj] = useState({
        start_date: '',
        end_date: '',
        uuid_board: [boardUuid]
    });

    const formatDate = (date) => {
        if (date) {
            const formattedDate = moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
            return formattedDate;
        } else {
            return '';
        }
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleClickOpenDialog = () => {
        setOpen(true);
    };

    const handleSuccess = (response) => {
        const data = response.data;
        setRows(data.rows);
        setTotal(data.filtered);
    };

    const getBoardHistoryApi = useApi(VenueService.getBoardLog, handleSuccess);

    useEffect(() => {
        getBoardHistoryApi.execute({
            limit,
            skip: (page * limit) - limit,
            searchValue: searchText.trim(),
            filter: filterObj
        });
    }, [searchText, page, limit, reload, filterObj]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard >
                <Grid container justifyContent="space-between" alignItems="center" spacing={2} >
                    <Grid item xs={12} sm={3}> </Grid>
                    <Grid item xs={12} sm={9} sx={{ textAlign: 'right', display: 'flex', justifyContent: 'end' }}>
                        <Typography variant='h4' sx={{ mt: 1, pr: 2 }}>
                            {filterObj.start_date ? `${formatDate(filterObj.start_date)} - ${formatDate(filterObj.end_date)}` : 'No Filtered'}
                        </Typography>
                        <Tooltip title="Filter">
                            <IconButton
                                size="large"
                                onClick={handleClickOpenDialog}
                                sx={{ boxShadow: 'none', ml: 1, width: 32, height: 32, minHeight: 32 }}
                            >
                                <FilterListIcon />
                            </IconButton>
                        </Tooltip>
                        <Filter
                            open={open}
                            handleCloseDialog={handleCloseDialog}
                            filterObj={filterObj}
                            setFilterObj={setFilterObj}
                            setPage={setPage}
                        />
                    </Grid>
                </Grid>
                <List
                    rows={rows}
                    limit={limit}
                    page={page}
                    setReload={setReload}
                />
                <PaginationRows
                    total={total}
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    limits={[10, 15, 20]}
                />
            </MainCard>
        </Box>
    )
}

export default BoardLog;
